import { createSelector } from '@ngrx/store';
import { getSpecificationProducts, getSpecificationProductUnits } from '../../../reducers';
import { State } from '../reducers/specification/product-unit.reducer';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { _safe } from '../../../../../modules/shared/utils/safe-get.method';

export const getProductUnitsWithDefaults = createSelector(
  getSpecificationProductUnits,
  getSpecificationProducts,
  (units, products) => {
    const defaultProductUnits = products.reduce((acc, current) => {
      return {
        ...acc,
        [_safe(() => current.productId || current.product.productId)]: current.unitOfMeasure,
      };
    }, {});

    return {
      units,
      defaultProductUnits,
    };
  },
);

export const getContractUnit = createSelector(
  getSpecificationProductUnits,
  getSpecificationProducts,
  (productUnits: State, specificationProducts: IProduct[]) => {
    return { productUnits, specificationProducts };
  },
);
